import { useQuery } from 'react-query'
import ApiClient from '../lib/api-client'

async function fetchStatistic (reportType) {
  const url = '/community/statistic?reportType=' + reportType
  return ApiClient.get(url).then(data => data)
}

function useStatistic (reportType, opt = {}) {
  return useQuery(
    ['statistic', reportType],
    () => fetchStatistic(reportType),
    opt
  )
}

export function useStatQueryCount () {
  return useStatistic('QUERY_COUNT', {
    staleTime: 1000 * 60
  })
}

export function useStatPurchaseInfo () {
  return useStatistic('PURCHASE_INFO', {
    staleTime: 30 * 1000 * 60 // 30 minutes
  })
}

export function useStatSubscriptionDate () {
  return useStatistic('SUBSCRIPTION_END_DATE', {
    staleTime: 30 * 1000 * 60 // 30 minutes
  })
}

export function useStatLicensedSeatCount () {
  return useStatistic('SEAT_COUNT', {
    staleTime: 30 * 1000 * 60 // 30 minutes
  })
}

export function useStatLicensedSeatAssigned () {
  return useStatistic('SEAT_ASSIGNED', {
    staleTime: 30 * 1000 * 60 // 30 minutes
  })
}

export function useStatAssignedUsers () {
  return useStatistic('ASSIGNED_USERS', {
    staleTime: 30 * 1000 * 60 // 30 minutes
  })
}

export function useIRSStatusOpt (options) {
  return useStatistic('IRS_STATUS', options)
}

export function useIpAddress (code, options) {
  const action = 'IP_ADDRESS'
  const url = Boolean(code) === true ? `/community/account-setup/${code}?action=${action}` : `/community/statistic?reportType=${action}`
  const tag = Boolean(code) === true ? 'account-setup' : 'statistic'
  return useQuery(
    [tag, code, action],
    () => ApiClient.get(url).then(data => data),
    options
  )
}
